import api from "./index";

/**
 * Create full farm with all gardens, harvest, and irrigation
 * @param {string} farm_name
 * @param {Array} gardens
 * @param {number} user_id
 */
export async function createFarm(
    farm_name,
    gardens,
    user_id
) {
    const res = await api.post(
        "/farm/createFull",
        {
            farm_name,
            gardens,
            user_id
        }
    );

    return res.data;
}